import axiosInstance from '../../../../../services/axios/axios';
import { then } from '../../../../../services/axios/_utility';

/**
 * Asynchronously retrieves email suffix list
 *
 * @function
 * @returns {string[]} array of email suffix.
 */
 export const getEmailSuffix = () => {
    return axiosInstance
        .get(
            `api/CustomValidation/List/EMAIL_SUFFIX_LIST`
        )
        .then(response => {
            return then(response, payload => payload);
        })
        .catch(error => {
            throw error;
        });
};